import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  addFilterButton: {
    fontWeight: 900,
    paddingTop: '16px !important',
    selectors: {
      '&:focus': {
        outline: 'thin !important',
      },
    },
  },
  panelHeading: {
    selectors: {
      '.ms-Panel-headerText': {
        padding: `${pxToRem(14)} 0 ${pxToRem(4)} ${pxToRem(8)}`,
        borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
      },
    },
  },
});
